export default "__VITE_ASSET__DWVpU2cO__"